<template>
  <div class="">
    <div class="card border-0 shadow-sm">
      <div class="card-body">
        <div class="">
          <p class="fw-bold mb-0 text-black-50">
           <small> <i class="fa-solid fa-eye text-info"></i></small>
            New Visitors
          </p>
          <hr class="mt-1">
          <div class="d-flex justify-content-between">
            <div class="">
              <img v-for="image in userImages" :src="require('../assets/user_images/'+ image)" alt="" class="visitor-image">
            </div>
            <div class="">
              <small class="fw-bold text-black-50">
                Today Visitor Totals
              </small>
              <br>
              <small class="fw-bold text-black">
                200
                <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
              </small>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <p class="fw-bold mb-0 text-black-50">
            <small><i class="text-success fa-solid fa-user-check"></i></small>
            New Users
          </p>
          <hr class="mt-1">
          <div class="d-flex justify-content-between">
            <div class="">
              <img v-for="image in newUsers" :src="require('../assets/user_images/'+ image)" alt="" class="visitor-image">
            </div>
            <div class="">
              <small class="fw-bold text-black-50">Today New User Totals</small>
              <br>
              <small class="fw-bold text-black">
                3
                <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewUsersAndVisitor",
  data() {
    return {
      userImages: ['1.jpeg', '11.jpeg', '3.jpeg', '33.jpeg', '4.jpeg'],
      newUsers : ['5.jpeg', '55.jpeg', '66.jpeg'],
    }
  },
}
</script>

<style scoped>
.visitor-image:first-child{
  margin-left: 0;
}
.visitor-image{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-left: -15px;
  border: 2px solid #7386D5;
  transition: .5s;
}
.visitor-image:hover{
  transform: scale(1.3);
}
</style>